/**
 * Expense Utility Functions
 * Helper functions for Expense component
 */

/**
 * Format user name for display
 * @param {Object} user - User object
 * @returns {string} Formatted user name
 */
export const formatUserName = (user) => {
  if (!user) return "";
  
  if (user.first_name) {
    return `${user.first_name} ${user.middle_name && user.middle_name !== "null" ? user.middle_name + " " : ""}${user.last_name || ""}`.trim();
  } else if (user.company_first_name) {
    return `${user.company_first_name} ${user.company_last_name || ""}`.trim();
  } else {
    return `${user.company_name || ""} (Company)`;
  }
};

/**
 * Check if user can view all users (admin/manager roles)
 * @param {number} userType - User type constant
 * @returns {boolean} True if user can view all users
 */
export const canViewAllUsers = (userType) => {
  return userType === 1 || userType === 2 || userType === 6 || userType === 7;
};

/**
 * Check if user can filter by teams
 * @param {number} userType - User type constant
 * @returns {boolean} True if user can filter by teams
 */
export const canFilterByTeam = (userType) => {
  return userType === 1 || userType === 2 || userType === 6 || userType === 7;
};
